/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class DiscountField extends PureComponent {
  render() {
    const { onChange, value } = this.props

    return (
      <Form.Field required>
        <label>Discount Rate</label>
        <Input
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          onChange={e => onChange(e.target.value)}
          value={value}
          required
          min={1}
          step={0.1}
          max={100}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/promotions/fields/discountField.js